import { testResultSchema } from '../testResultSchema'

// 分類定数・フォーム表示用スキーマのみここに置く。OCR専用のプロンプト・OCR出力スキーマは
// @mbscan/backend-ocr（packages/backend/ocr/src/categories/document/schemas/todaHoukokuyso.ts）が正本。

export const todaHoukokusyoDocumentNameText = '打設報告書_戸田建設'
export const todaHoukokusyoDocumentType = '打設報告書'
export const todaHoukokusyoDocumentType2 = '打設計画書' // ほぼ同じ帳票なので、nameは同じで、typeが違う形で処理する
export const todaHoukokusyoGeneralContractorName = '戸田建設'

export const todaHoukokusyoFormFieldsSchema = testResultSchema.pick({
  打設番号: true,
  打設日: true,
  打設箇所: true,
  CON数量_m3: true,
  Fc_N_per_mm2: true,
  Fq_N_per_mm2: true,
  種類: true,
  呼び強度: true,
  スランプ_cm: true,
  骨材寸法_mm: true,
  セメント: true,
  プラント名: true,
  // 試験機関名は OCR/検査会社名メタデータ由来の派生値（string[]）で手編集対象にしないため、編集モーダルには出さない。
  判定基準強度: true,
})
